export default __webpack_public_path__ + "static/media/2022_Juli_Wald.1a39f2c4.webp";